module.exports = __webpack_public_path__ + "static/media/filled_bar_postinspect_tall.0dc949bf.svg";